import moment from 'moment/src/moment'

function getSuffix (val, arr) {
  const cases = [2, 0, 1, 1, 1, 2]
  return arr[(val % 100 > 4 && val % 100 < 20) ? 2 : cases[(val % 10 < 5) ? val % 10 : 5]]
}

function getCroppedImg (url, [width, height]) {
  if (!url) {
    return null
  }

  const w = width || '-'
  const h = height || '-'

  return url.replace('/-x-/', `/${w}x${h}/`)
}

function getShortMonth (date, isMoment) {
  if (!date) {
    return false
  }
  const d = isMoment ? date : moment(date)
  return d.format('MMM').slice(0, 3)
}

function getCalendarDate (date) {
  const d = moment(moment.utc(date).toDate()).local()
  const format = 'DD MMMM YYYY'
  return {
    date: d.calendar(null, {
      sameDay: '[Сегодня]',
      nextDay: '[Завтра]',
      lastDay: '[Вчера]',
      nextWeek: format,
      lastWeek: format,
      sameElse: format
    }),
    time: d.format('HH:MM'),
    isToday: d.isSame(moment(), 'day'),
    isYesterday: d.isSame(moment().subtract(1, 'days'), 'day')
  }
}

function isCurrentYear (momentDate) {
  if (!momentDate) {
    return false
  }
  return momentDate.isSame(moment(), 'year')
}

function formatDateRange ([start, end]) {
  if (!start) {
    return null
  }

  const startDate = moment(start)
  const endDate = end ? moment(end) : null
  const yearFormat = isCurrentYear(startDate) ? '' : '[&nbsp;]YYYY'

  // One day
  if (!endDate || startDate.isSame(endDate, 'day')) {
    return startDate.format(`DD[&nbsp;]MMMM${yearFormat}`)
  }

  // One month
  if (startDate.isSame(endDate, 'month')) {
    const startFormat = 'DD'
    const endFormat = `DD[&nbsp;]MMMM${yearFormat}`
    return `${startDate.format(startFormat)}–${endDate.format(endFormat)}`
  }

  // One year
  if (startDate.isSame(endDate, 'year')) {
    const startFormat = `DD[&nbsp;][${getShortMonth(startDate)}]`
    const endFormat = `DD[&nbsp;][${getShortMonth(endDate)}]${yearFormat}`
    return `${startDate.format(startFormat)} – ${endDate.format(endFormat)}`
  }

  const startFormat = `DD[&nbsp;][${getShortMonth(startDate)}]${yearFormat}`
  const endFormat = `DD[&nbsp;${getShortMonth(endDate)}]${yearFormat}`
  return `${startDate.format(startFormat)} – ${endDate.format(endFormat)}`
}

function getEnvVar (name) {
  if (!name) {
    return null
  }
  const tenant = process.env.VUE_APP_TENANT
  const postfix = (!tenant || tenant === 'rr') ? '' : `_${tenant.toUpperCase()}`
  return process.env[name + postfix] || process.env[name]
}

export {
  getSuffix,
  getCroppedImg,
  getShortMonth,
  getCalendarDate,
  formatDateRange,
  getEnvVar
}
